import React, { useState, useEffect } from "react"
import { Link, navigate } from "gatsby"
import myImage from "../images/MBMAORG-logo.png"
import "./menu.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAccessibleIcon } from "@fortawesome/free-brands-svg-icons"
import footer from "../images/footer_image.jpg"
import { faSearch, faUniversalAccess } from "@fortawesome/free-solid-svg-icons"
import AnalyticsDashboard from "./analyticsdashboard"
import { StaticImage } from "gatsby-plugin-image"
const MyLayout = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [activemenuLink, setactivemenuLink] = useState("/")

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const handlePageChange = (path) => {
    setactivemenuLink(path)
    toggleMenu()
  }

  useEffect(() => {
    const activemenuPath = localStorage.getItem("activemenuPath")
    if (activemenuPath) {
      setactivemenuLink(activemenuPath)
    }
  }, [])

  useEffect(() => {
    localStorage.setItem("activemenuPath", activemenuLink)
  }, [activemenuLink])

  const [fontSize, setFontSize] = useState(14)
  const defaultFontSize = 14
  function handleIncreaseFontSize() {
    setFontSize(fontSize + 2)
  }

  function handleDecreaseFontSize() {
    setFontSize(fontSize - 2)
  }
  function handleResetFontSize() {
    setFontSize(defaultFontSize)
  }

  // const [title, setTitle] = React.useState("")
  const [title, setTitle] = useState("")

  const handleInputChange = (event) => {
    setTitle(event.target.value)
  }

  const [showModal, setShowModal] = React.useState(false)
  const modalRef = React.useRef()

  const handleModalClick = (e) => {
    e.stopPropagation()
  }

  const handleOverlayClick = () => {
    setShowModal(false)
  }

  const search = () => {
    if (title !== "") {
      setShowModal(false)
      navigate(`/search/?title=${encodeURIComponent(title)}`)
    }
  }

  function handleIncreaseFontSize() {
    setFontSize(fontSize + 2)
  }

  function handleDecreaseFontSize() {
    setFontSize(fontSize - 2)
  }

  function handleResetFontSize() {
    setFontSize(14)
  }

  const handleSkipToMainContent = () => {
    const section = document.querySelector("#main-content")
    const offset = 100 // Change this value to adjust the amount of padding
    const elementPosition = section.getBoundingClientRect().top
    const offsetPosition = elementPosition - offset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }
  const handleSearch = () => {
    // Perform search using the input value
    // Update searchResults state with the results
  }

  return (
    <div>
      <section className="overlay z-10 w-full bg-teal-600 text-white flex justify-end items-center">
        <div className="mr-auto pl-2 poppins-regular">
          Government of Meghalaya
        </div>
        <div className="secondary-dropdown lg:!block !hidden">
          <button
            aria-label="Skip to main content"
            title="Skip to main content"
            className="px-3 border-x-2 py-2 text-white"
            onClick={handleSkipToMainContent}
          >
            <span className="text-sm poppins-regular">
              Skip to main content
            </span>
          </button>
        </div>
        <div className="secondary-dropdown">
          <button
            aria-label="Accessible"
            className="px-3 py-2 text-white secondary-dropbtn"
          >
            <FontAwesomeIcon
              className="font-bold"
              icon={faAccessibleIcon}
              size="1x"
            />
          </button>
          <div className="secondary-dropdown-content cursor-pointer font-bold">
            <a href={void 0} onClick={handleIncreaseFontSize}>
              A<sup>+</sup>
            </a>
            <a href={void 0} onClick={handleResetFontSize}>
              A
            </a>
            <a href={void 0} onClick={handleDecreaseFontSize}>
              A<sup>-</sup>
            </a>
          </div>
        </div>
        <div className="secondary-dropdown">
          <Link
            title="Screen reader access"
            className="border-l-2 px-3 py-2 text-white secondary-dropbtn"
            to="/screen_reader"
          >
            <FontAwesomeIcon
              className="font-bold"
              icon={faUniversalAccess}
              size="1x"
            />
          </Link>
        </div>
        <div className="secondary-dropdown">
          <button
            aria-label="Search"
            title="Search Content"
            className="border-l-2 px-3 py-2 text-white secondary-dropbtn"
            onClick={() => setShowModal(true)}
          >
            <FontAwesomeIcon className="font-bold" icon={faSearch} size="1x" />
          </button>
        </div>
        {showModal ? (
          <>
            <div
              onClick={handleOverlayClick}
              className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
              <div
                ref={modalRef}
                onClick={handleModalClick}
                className="border-0 rounded-full shadow-lg relative flex flex-col bg-white outline-none focus:outline-none"
              >
                <div className="relative flex-auto">
                  <div className="container flex justify-center items-center">
                    <div className="relative">
                      <input
                        value={title}
                        onChange={handleInputChange}
                        type="text"
                        className="text-gray-800 text-sm pl-3 rounded-full pr-16 z-0 focus:shadow focus:outline-none lg:h-14 lg:w-96 sm:h-18 sm:w-60  "
                        placeholder="Search anything..."
                      />
                      <div className="absolute top-1 right-1">
                        <button
                          to={`/search?title=${encodeURIComponent(title)}`}
                          onClick={search}
                          className="h-12 w-12 text-white rounded-full py-3 px-5 bg-gray-800 hover:bg-gray-600"
                        >
                          <FontAwesomeIcon
                            title="Search"
                            className="font-bold"
                            icon={faSearch}
                            size="1x"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="backdrop-blur-sm opacity-50 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}
      </section>
      <header
        className="poppins-semibold w-full menu-bg z-10  shadow-md fixed top-10 right-0 "
        style={{ fontSize: `${fontSize}px` }}
      >
        <div
          className="w-full md:w-full md:px-0 h-full mx-auto flex justify-between items-center text-sm px-4"
          style={{ fontSize: `${fontSize}px` }}
        >
          <Link to="/" className={`pl-2 ${isOpen ? "hidden" : ""}`}>
            <img src={myImage} alt="My Image" className="w-44 h-16" />
          </Link>

          <ul
            id="menu"
            className={`${
              isOpen ? "" : "hidden"
            } fixed top-0 right-0 px-10 py-16
                md:relative menu-bg  lg:flex md:p-0 md:bg-white-900 lg:flex-row lg:space-x-6 lg:w-auto md:w-full w-full`}
          >
            <li className="lg:hidden fixed top-4 right-6 mt-10">
              <button
                className="text-right text-white text-6xl"
                onClick={toggleMenu}
              >
                &times;
              </button>
            </li>
            <li className="lg:h-[83px] md:h-full h-full flex items-center px-2">
              <Link
                className={`text-white  my-2  p-2 hover:text-amber-500  ${
                  activemenuLink === "/" ? "activemenu" : ""
                }`}
                to="/"
                onClick={() => {
                  handlePageChange("/");
                  setIsOpen(false);
                }}
              >
                HOME
              </Link>
            </li>
            <li>
              <div className="group inline-block">
                <div className="flex items-center  lg:h-[83px] md:h-full h-full">
                  {" "}
                  <Link
                    to="/main-menu-page/Who_we_are"
                    className={`text-sm text-white hover:text-amber-500 lg:px-2 3xl:py-8 2xl:py-4 xl:py-4 lg:py-4 md:px-4 md:py-4 px-2 py-2 
                    ${activemenuLink === "/whoiswho" ? "activemenu" : ""}
                    ${activemenuLink === "/about" ? "activemenu" : ""}
                    ${activemenuLink === "/grievance" ? "activemenu" : ""}
                    ${activemenuLink === "/mbda" ? "activemenu" : ""}
                    ${
                      activemenuLink === "/main-menu-page/Who_we_are"
                        ? "activemenu"
                        : ""
                    }
                  `}
                  >
                    WHO WE ARE
                  </Link>
                  <span>
                    <svg
                      className="fill-current h-4 w-4 transform group-hover:-rotate-180 text-white  ease-in-out  "
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </span>
                </div>

                <ul className="text-white transform scale-0 group-hover:scale-100 absolute ease-in-out min-w-32 z-40 p-4 Ul_bgcolor border-t-[1px] border-gray-50 border-opacity-20 ">
                  <li className="my-2">
                    <Link
                      className={`hover:text-amber-500 block py-2 px-4 my-1 text-sm font- bold  ${
                        activemenuLink === "/about" ? "activemenu" : ""
                      }`}
                      to="/about"
                      onClick={() => {handlePageChange("/about");
                        setIsOpen(false);}}
                    >
                      About US
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link
                      className={`hover:text-amber-500    block py-2 px-4 my-1 text-sm font- bold    ${
                        activemenuLink === "/whoiswho" ? "activemenu" : ""
                      }`}
                      to="/Who_is_who"
                      onClick={() => {handlePageChange("/whoiswho");
                        setIsOpen(false);}}
                    >
                      Who is Who
                    </Link>
                  </li>
                  <li className="my-2 p-2">
                    <Link
                      className={`text-white p-2  hover:text-amber-500  ${
                        activemenuLink === "/grievance" ? "activemenu" : ""
                      }`}
                      to="/grievance"
                      onClick={() => {handlePageChange("/grievance");
                        setIsOpen(false);}}
                    >
                      Grievance Redressal
                    </Link>
                  </li>

                  <li>
                    <a
                      className={`hover:text-amber-500 block py-2 px-4 my-1 text-sm font-bold ${
                        activemenuLink === "/mda" ? "activemenu" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault() // Prevent the default link behavior

                        window.open("https://mbda.gov.in/", "_blank") // Open the link in a new tab
                      }}
                      href="https://mbda.gov.in/" // Keep the href for accessibility purposes
                    >
                      Visit MBDA Website
                    </a>
                  </li>
                </ul>
              </div>
            </li>

            <div class="group inline-block relative">
              <div className="flex items-center lg:h-[83px] md:h-full h-full">
                <Link
                  to="/main-menu-page/What_we_do"
                  className={`lg:px-2 3xl:py-8 2xl:py-4 xl:py-4 lg:py-4 md:px-4 md:py-4 px-2 py-2 text-sm flex-1 text-white my-0 hover:text-amber-500
      ${activemenuLink === "/mlamp" ? "activemenu" : ""}
      ${activemenuLink === "/cllmp" ? "activemenu" : ""}
      ${activemenuLink === "/slm" ? "activemenu" : ""}
      ${activemenuLink === "/pmjvm" ? "activemenu" : ""}
      ${activemenuLink === "/Natural_Resources" ? "activemenu" : ""}
      ${activemenuLink === "/Rural_Finance" ? "activemenu" : ""}
      ${activemenuLink === "/Supply_Chain" ? "activemenu" : ""}
      ${activemenuLink === "/Enterprise_Development" ? "activemenu" : ""}
      ${activemenuLink === "/Strengthening_Capacity" ? "activemenu" : ""}
       ${
         activemenuLink === "/NRM_Planning_and_Implementation"
           ? "activemenu"
           : ""
       }
        ${activemenuLink === "/Organic_Farming" ? "activemenu" : ""}
         ${activemenuLink === "/Value_Addition" ? "activemenu" : ""}
          ${activemenuLink === "/Market_Linkages" ? "activemenu" : ""}
          ${activemenuLink === "/Organic_Certification" ? "activemenu" : ""}
    `}
                >
                  WHAT WE DO
                </Link>
                <span>
                  <svg
                    className="fill-current h-4 w-4 transform group-hover:-rotate-180 transition duration-150 ease-in-out text-white bold"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </span>
              </div>

              {/* FOR LARGE SCREEN */}
              <ul className="hidden lg:fixed lg:top-0 lg:mt-[123px] lg:left-0 lg:w-full text-white shadow-lg p-6 z-50 lg:block transform scale-0 group-hover:scale-100 Ul_bgcolor border-t-[1px] border-gray-50 border-opacity-20">
                <div className="max-w-full mx-auto grid lg:grid-cols-2 md:grid-cols-2 grid-cols-2 gap-8">
                  {/* <li class=" ">
                  <Link
                    to="/mlamp/mlamp"
                    onClick={() => handlePageChange("/mlamp")}
                    className=""
                  >
                    <span
                      class={`
         ${activemenuLink === "/mlamp" ? "activemenu" : ""} 
         ${activemenuLink === "/Natural_Resources" ? "activemenu" : ""}
        ${activemenuLink === "/Rural_Finance" ? "activemenu" : ""}
        ${activemenuLink === "/Supply_Chain" ? "activemenu" : ""} 
        ${activemenuLink === "/Enterprise_Development" ? "activemenu" : ""}
         `}
                    >
                      MLAMP
                    </span>
               
                  </Link>
                  <ul
                    class=""

                  >
                    <li className="my-2  mx-4">
                      {" "}
                      
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold  ${
                          activemenuLink === "/Natural_Resources"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/mlamp/natural_resource"
                        onClick={() => handlePageChange("/Natural_Resources")}
                      >
                        Natural Resources
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold ${
                          activemenuLink === "/Rural_Finance"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/mlamp/rural_finance"
                        onClick={() => handlePageChange("/Rural_Finance")}
                      >
                        Rural Finance
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold  ${
                          activemenuLink === "/Supply_Chain" ? "activemenu" : ""
                        }`}
                        to="/mlamp/supply_chain"
                        onClick={() => handlePageChange("/Supply_Chain")}
                      >
                        Supply Chain
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold ${
                          activemenuLink === "/Enterprise_Development"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/mlamp/enterprise_development/"
                        onClick={() =>
                          handlePageChange("/Enterprise_Development")
                        }
                      >
                        Enterprise Development
                      </Link>
                    </li>
                  </ul>
                </li> */}
                  <div className="flex justify-start">
                    <div className="w-1/2 h-52 mr-2 hidden lg:block">
                      <Link
                        to="/mlamp/mlamp"
                        onClick={() => {handlePageChange("/mlamp");
                          setIsOpen(false);}}
                      >
                        <StaticImage
                          src="../images/mlamp.jpg"
                          alt="MLAMP"
                          className="w-full h-full object-cover"
                        />
                      </Link>
                    </div>
                    <div className="">
                      <Link
                        to="/mlamp/mlamp"
                        onClick={() => {handlePageChange("/mlamp");
                          setIsOpen(false);}}
                        className="w-full text-left flex items-center outline-none focus:outline-none cursor-pointer hover:no-underline"
                      >
                        <span
                          class={`w-full hover:text-amber-500  block py-2 px-4 my-1 text-sm
         ${activemenuLink === "/mlamp" ? "activemenu" : ""} 
         ${activemenuLink === "/Natural_Resources" ? "activemenu" : ""}
        ${activemenuLink === "/Rural_Finance" ? "activemenu" : ""}
        ${activemenuLink === "/Supply_Chain" ? "activemenu" : ""} 
        ${activemenuLink === "/Enterprise_Development" ? "activemenu" : ""}
         `}
                        >
                          MLAMP
                        </span>
                      </Link>
                      <ul className="px-1">
                        <li className="p-1 hover:text-orange-500">
                          <Link
                            className={` hover:text-amber-500  block  px-4 my-1 text-sm ${
                              activemenuLink === "/Natural_Resources"
                                ? "activemenu"
                                : ""
                            }`}
                            to="/mlamp/natural_resource"
                            onClick={() =>
                              {handlePageChange("/Natural_Resources");
                                setIsOpen(false);}
                            }
                          >
                            Natural Resources
                          </Link>
                        </li>
                        <li className="p-1 hover:text-orange-500">
                          <Link
                            className={` hover:text-amber-500  block  px-4 my-1 text-sm ${
                              activemenuLink === "/Rural_Finance"
                                ? "activemenu"
                                : ""
                            }`}
                            to="/mlamp/rural_finance"
                            onClick={() => {handlePageChange("/Rural_Finance");
                              setIsOpen(false);}}
                          >
                            Rural Finance
                          </Link>
                        </li>
                        <li className="p-1 hover:text-orange-500">
                          <Link
                            className={` hover:text-amber-500  block  px-4 my-1 text-sm ${
                              activemenuLink === "/Supply_Chain"
                                ? "activemenu"
                                : ""
                            }`}
                            to="/mlamp/supply_chain"
                            onClick={() => {handlePageChange("/Supply_Chain");
                              setIsOpen(false);}}
                          >
                            Supply Chain
                          </Link>
                        </li>
                        <li className="p-1 hover:text-orange-500">
                          <Link
                            className={` hover:text-amber-500  block px-4 my-1 text-sm ${
                              activemenuLink === "/Enterprise_Development"
                                ? "activemenu"
                                : ""
                            }`}
                            to="/mlamp/enterprise_development/"
                            onClick={() =>
                              {handlePageChange("/Enterprise_Development");
                                setIsOpen(false);}
                            }
                          >
                            Enterprise Development
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* <li class=" ">
                  <Link
                    to="/cllmp/cllmp"
                    onClick={() => handlePageChange("/cllmp")}
                    className="w-full text-left flex items-center outline-none focus:outline-none cursor-pointer hover:no-underline"
                  >
                    <span
                      class={`w-full hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold
          ${activemenuLink === "/cllmp" ? "activemenu" : ""} 
          ${activemenuLink === "/Strengthening_Capacity" ? "activemenu" : ""}
          ${
            activemenuLink === "/NRM_Planning_and_Implementation"
              ? "activemenu"
              : ""
          } 
          ${activemenuLink === "/Visit_Project_Website" ? "activemenu" : ""} 
          `}
                    >
                      CLLMP
                    </span>
                    
                  </Link>
                  <ul
                    class="text-white absolute    transition duration-150 ease-in-out  hover:no-underline Ul_bgcolor"
                    style={{ width: "100%" }}
                  >
                    <li className="my-2 mx-4">
                      {" "}
                      CLLMP
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold ${
                          activemenuLink === "/Strengthening_Capacity"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/cllmp/strengthening_capacity"
                        onClick={() =>
                          handlePageChange("/Strengthening_Capacity")
                        }
                      >
                        Strengthening Capacity
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold ${
                          activemenuLink === "/NRM_Planning_and_Implementation"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/cllmp/nrl_planing/"
                        onClick={() =>
                          handlePageChange("/NRM_Planning_and_Implementation")
                        }
                      >
                        NRM Planning and Implementation
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold ${
                          activemenuLink === "/Visit_Project_Website"
                            ? "activemenu"
                            : ""
                        }`}
                        to="https://www.cllmp.com/"
                        onClick={() =>
                          handlePageChange("/Visit_Project_Website")
                        }
                      >
                        Visit Project Website
                      </Link>
                    </li>
                  </ul>
                </li> */}
                  <div className="flex justify-start">
                    <div className="w-1/2 h-52 mr-2 hidden lg:block">
                      <Link
                        to="/cllmp/cllmp"
                        onClick={() => {handlePageChange("/cllmp");
                          setIsOpen(false);}}
                      >
                        <StaticImage
                          src="../images/cllmp.jpg"
                          alt="MLAMP"
                          className="w-full h-full object-cover"
                        />
                      </Link>
                    </div>
                    <div className="">
                      <Link
                        to="/cllmp/cllmp"
                        onClick={() => {handlePageChange("/cllmp");
                            setIsOpen(false);}}
                        className="w-full text-left flex items-center outline-none focus:outline-none cursor-pointer hover:no-underline"
                      >
                        <span
                          class={`w-full hover:text-amber-500  block py-2 px-4 my-1 text-sm
           ${activemenuLink === "/cllmp" ? "activemenu" : ""} 
          ${activemenuLink === "/Strengthening_Capacity" ? "activemenu" : ""}
          ${
            activemenuLink === "/NRM_Planning_and_Implementation"
              ? "activemenu"
              : ""
          } 
          ${activemenuLink === "/Visit_Project_Website" ? "activemenu" : ""} 
          `}
                        >
                          CLLMP
                        </span>
                      </Link>
                      <ul className="px-1">
                        <li className="p-1 hover:text-orange-500">
                          <Link
                            className={` hover:text-amber-500  block  px-4 my-1 text-sm ${
                              activemenuLink === "/Strengthening_Capacity"
                                ? "activemenu"
                                : ""
                            }`}
                            to="/cllmp/strengthening_capacity"
                            onClick={() =>
                              {handlePageChange("/Strengthening_Capacity");
                                setIsOpen(false);}
                            }
                          >
                            Strengthening Capacity
                          </Link>
                        </li>
                        <li className="p-1 hover:text-orange-500">
                          <Link
                            className={` hover:text-amber-500  block px-4 my-1 text-sm ${
                              activemenuLink ===
                              "/NRM_Planning_and_Implementation"
                                ? "activemenu"
                                : ""
                            }`}
                            to="/cllmp/nrl_planing/"
                            onClick={() =>
                              {handlePageChange(
                                "/NRM_Planning_and_Implementation"
                              );
                              setIsOpen(false);}
                            }
                          >
                            NRM Planning and Implementation
                          </Link>
                        </li>
                        <li className="p-1 hover:text-orange-500">
                          <Link
                            className={` hover:text-amber-500  block  px-4 my-1 text-sm ${
                              activemenuLink === "/Visit_Project_Website"
                                ? "activemenu"
                                : ""
                            }`}
                            to="https://www.cllmp.com/"
                            onClick={() =>
                              handlePageChange("/Visit_Project_Website")
                            }
                          >
                            Visit Project Website
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* <li class=" ">
                  <Link
                    to="/sustainable_land_management/sustainable_land_management/"
                    onClick={() => handlePageChange("/slm")}
                    className="w-full text-left flex items-center outline-none focus:outline-none cursor-pointer hover:no-underline"
                  >
                    <span
                      class={`w-full hover:text-amber-500  block py-2 px-4 my-1 text-sm
          ${activemenuLink === "/slm" ? "activemenu" : ""} 
          ${activemenuLink === "/Organic_Farming" ? "activemenu" : ""}
         ${activemenuLink === "/Value_Addition" ? "activemenu" : ""}
          ${activemenuLink === "/Market_Linkages" ? "activemenu" : ""}
          ${activemenuLink === "/Organic_Certification" ? "activemenu" : ""}
          `}
                    >
                      SLM
                    </span>
                    <span class="mr-auto">
                      <svg
                        class="fill-current h-4 w-4
            transition duration-150 ease-in-out"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </span>
                  </Link>
                  <ul
                    class="text-white absolute    transition duration-150 ease-in-out  hover:no-underline Ul_bgcolor"
                    style={{ width: "100%" }}
                  >
                    <li className="my-2 mx-4">
                      {" "}
                      SLM
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm ${
                          activemenuLink === "/Organic_Farming"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/sustainable_land_management/organic_farming_production_and_diversification/"
                        onClick={() => handlePageChange("/Organic_Farming")}
                      >
                        Organic Farming
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm ${
                          activemenuLink === "/Value_Addition"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/sustainable_land_management/value_addition _&_upgradation _of_aggregation_infrastructure"
                        onClick={() => handlePageChange("/Value_Addition")}
                      >
                        Value Addition
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm ${
                          activemenuLink === "/Market_Linkages"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/sustainable_land_management/establishing_effective_market_linkages/"
                        onClick={() => handlePageChange("/Market_Linkages")}
                      >
                        Market Linkages
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm ${
                          activemenuLink === "/Organic_Certification"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/sustainable_land_management/organic_certification_for_premier_organic_markets/"
                        onClick={() =>
                          handlePageChange("/Organic_Certification")
                        }
                      >
                        Organic Certification
                      </Link>
                    </li>
                  </ul>
                </li> */}
                  <div className="flex justify-start">
                    <div className="w-1/2 h-52 mr-2 hidden lg:block">
                      <Link
                        to="/sustainable_land_management/sustainable_land_management/"
                        onClick={() => {handlePageChange("/slm");
                          setIsOpen(false);}}
                      >
                        <StaticImage
                          src="../images/SLM.png"
                          alt="MLAMP"
                          className="w-full h-full object-cover"
                        />
                      </Link>
                    </div>

                    <div>
                      <Link
                        to="/sustainable_land_management/sustainable_land_management/"
                        onClick={() => {handlePageChange("/slm");
                          setIsOpen(false);}}
                        className="w-full text-left flex items-center outline-none focus:outline-none cursor-pointer hover:no-underline"
                      >
                        <span
                          class={`w-full hover:text-amber-500  block py-2 px-4 my-1 text-sm
          ${activemenuLink === "/slm" ? "activemenu" : ""} 
          ${activemenuLink === "/Organic_Farming" ? "activemenu" : ""}
         ${activemenuLink === "/Value_Addition" ? "activemenu" : ""}
          ${activemenuLink === "/Market_Linkages" ? "activemenu" : ""}
          ${activemenuLink === "/Organic_Certification" ? "activemenu" : ""}
          `}
                        >
                          SLM
                        </span>
                      </Link>
                      <ul className="px-1">
                        <li className="p-1 hover:text-orange-500">
                          <Link
                            className={` hover:text-amber-500  block  px-4 my-1 text-sm ${
                              activemenuLink === "/Organic_Farming"
                                ? "activemenu"
                                : ""
                            }`}
                            to="/sustainable_land_management/organic_farming_production_and_diversification/"
                            onClick={() => {handlePageChange("/Organic_Farming");
                              setIsOpen(false);}}
                          >
                            Organic Farming
                          </Link>
                        </li>{" "}
                        <li className="p-1 hover:text-orange-500">
                          <Link
                            className={` hover:text-amber-500  block  px-4 my-1 text-sm ${
                              activemenuLink === "/Value_Addition"
                                ? "activemenu"
                                : ""
                            }`}
                            to="/sustainable_land_management/value_addition _&_upgradation _of_aggregation_infrastructure"
                            onClick={() => {handlePageChange("/Value_Addition");
                              setIsOpen(false);}}
                          >
                            Value Addition
                          </Link>
                        </li>{" "}
                        <li className="p-1 hover:text-orange-500">
                          <Link
                            className={` hover:text-amber-500  block  px-4 my-1 text-sm ${
                              activemenuLink === "/Market_Linkages"
                                ? "activemenu"
                                : ""
                            }`}
                            to="/sustainable_land_management/establishing_effective_market_linkages/"
                            onClick={() => {handlePageChange("/Market_Linkages");
                              setIsOpen(false);}}
                          >
                            Market Linkages
                          </Link>
                        </li>
                        <li className="p-1 hover:text-orange-500">
                          <Link
                            className={` hover:text-amber-500  block  px-4 my-1 text-sm ${
                              activemenuLink === "/Organic_Certification"
                                ? "activemenu"
                                : ""
                            }`}
                            to="/sustainable_land_management/organic_certification_for_premier_organic_markets/"
                            onClick={() =>
                              {handlePageChange("/Organic_Certification");
                                setIsOpen(false);}
                            }
                          >
                            Organic Certification
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="flex justify-left">
                    <div className="w-1/2 h-52 mr-2 hidden lg:block">
                      <Link
                        to="/pmjvm"
                        onClick={() => {handlePageChange("/pmjvm");
                          setIsOpen(false);}}
                      >
                        <StaticImage
                          src="../images/JINGKYRMEN VDVK.jpg"
                          alt="MLAMP"
                          className="w-full h-full object-cover"
                        />
                      </Link>
                    </div>
                    <div>
                      <Link
                        to="/pmjvm"
                        onClick={() => {handlePageChange("/pmjvm");
                          setIsOpen(false);}}
                        className="w-full text-left flex items-center outline-none focus:outline-none cursor-pointer hover:no-underline"
                      >
                        <span
                          class={`w-full hover:text-amber-500  block py-2 px-4 my-1 text-sm
             ${activemenuLink === "/pmjvm" ? "activemenu" : ""} 
          `}
                        >
                          PMJVM
                        </span>
                      </Link>
                    </div>
                  </div>
                  {/* <li class=" ">
                  <Link
                    to="/pmjvm"
                    onClick={() => handlePageChange("/pmjvm")}
                    className="w-full text-left flex items-center outline-none focus:outline-none cursor-pointer hover:no-underline"
                  >
                    <span
                      class={`w-full hover:text-amber-500  block py-2 px-4 my-1 text-sm
          ${activemenuLink === "/pmjvm" ? "activemenu" : ""} 
         
          `}
                    >
                   PMJVM
                    </span>
                    
                  </Link>
                 
                </li> */}
                </div>
              </ul>
              {/* FOR SMALL SCREEN */}
              <ul className="lg:hidden fixed lg:top-0 lg:mt-[123px] lg:left-0 lg:w-full text-white shadow-lg p-6 z-50 block transform scale-0 group-hover:scale-100 Ul_bgcolor border-t-[1px] border-gray-50 border-opacity-20">
                <li class=" ">
                  <div className="flex items-center w-full">
                    <Link
                      to="/mlamp/mlamp"
                      onClick={() => handlePageChange("/mlamp")}
                      className="w-full text-left flex items-center outline-none focus:outline-none cursor-pointer hover:no-underline"
                    >
                      <span
                        class={`w-full hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold 
                       ${activemenuLink === "/mlamp" ? "activemenu" : ""} 
                       ${
                         activemenuLink === "/Natural_Resources"
                           ? "activemenu"
                           : ""
                       }
                      ${activemenuLink === "/Rural_Finance" ? "activemenu" : ""}
                      ${activemenuLink === "/Supply_Chain" ? "activemenu" : ""} 
                      ${
                        activemenuLink === "/Enterprise_Development"
                          ? "activemenu"
                          : ""
                      }
                       
                       
                       `}
                      >
                        MLAMP
                      </span>
                    </Link>
                    <span class="mr-auto">
                      <svg
                        class="fill-current h-4 w-4
                          transition duration-150 ease-in-out"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </span>
                  </div>
                  <ul
                    class="text-white absolute  transition duration-150 ease-in-out   min-w-32 hover:no-underline Ul_bgcolor"
                    Ul_bgcolorstyle={{ width: "100%" }}
                  >
                    <li className="my-2  mx-4">
                      {" "}
                      MLAMP
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold  ${
                          activemenuLink === "/Natural_Resources"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/mlamp/natural_resource"
                        onClick={() => handlePageChange("/Natural_Resources")}
                      >
                        Natural Resources
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold ${
                          activemenuLink === "/Rural_Finance"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/mlamp/rural_finance"
                        onClick={() => handlePageChange("/Rural_Finance")}
                      >
                        Rural Finance
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold  ${
                          activemenuLink === "/Supply_Chain" ? "activemenu" : ""
                        }`}
                        to="/mlamp/supply_chain"
                        onClick={() => handlePageChange("/Supply_Chain")}
                      >
                        Supply Chain
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold ${
                          activemenuLink === "/Enterprise_Development"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/mlamp/enterprise_development/"
                        onClick={() =>
                          handlePageChange("/Enterprise_Development")
                        }
                      >
                        Enterprise Development
                      </Link>
                    </li>
                  </ul>
                </li>
                <li class=" ">
                  <div className="flex items-center w-full">
                    <Link
                      to="/cllmp/cllmp"
                      onClick={() => handlePageChange("/cllmp")}
                      className="w-full text-left flex items-center outline-none focus:outline-none cursor-pointer hover:no-underline"
                    >
                      <span
                        class={`w-full hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold
                        ${activemenuLink === "/cllmp" ? "activemenu" : ""} 
                        ${
                          activemenuLink === "/Strengthening_Capacity"
                            ? "activemenu"
                            : ""
                        }
                        ${
                          activemenuLink === "/NRM_Planning_and_Implementation"
                            ? "activemenu"
                            : ""
                        } 
                        ${
                          activemenuLink === "/Visit_Project_Website"
                            ? "activemenu"
                            : ""
                        } 
                        `}
                      >
                        CLLMP
                      </span>
                    </Link>
                    <span class="mr-auto">
                      <svg
                        class="fill-current h-4 w-4
                          transition duration-150 ease-in-out"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </span>
                  </div>
                  <ul
                    class="text-white absolute    transition duration-150 ease-in-out  hover:no-underline Ul_bgcolor"
                    style={{ width: "100%" }}
                  >
                    <li className="my-2 mx-4">
                      {" "}
                      CLLMP
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold ${
                          activemenuLink === "/Strengthening_Capacity"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/cllmp/strengthening_capacity"
                        onClick={() =>
                          handlePageChange("/Strengthening_Capacity")
                        }
                      >
                        Strengthening Capacity
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold ${
                          activemenuLink === "/NRM_Planning_and_Implementation"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/cllmp/nrl_planing/"
                        onClick={() =>
                          handlePageChange("/NRM_Planning_and_Implementation")
                        }
                      >
                        NRM Planning and Implementation
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold ${
                          activemenuLink === "/Visit_Project_Website"
                            ? "activemenu"
                            : ""
                        }`}
                        to="https://www.cllmp.com/"
                        onClick={() =>
                          handlePageChange("/Visit_Project_Website")
                        }
                      >
                        Visit Project Website
                      </Link>
                    </li>
                  </ul>
                </li>
                <li class=" ">
                  <div className="flex items-center w-full">
                    <Link
                      to="/sustainable_land_management/sustainable_land_management/"
                      onClick={() => handlePageChange("/slm")}
                      className="w-full text-left flex items-center outline-none focus:outline-none cursor-pointer hover:no-underline"
                    >
                      <span
                        class={`w-full hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold
                        ${activemenuLink === "/slm" ? "activemenu" : ""} 
                        ${
                          activemenuLink === "/Organic_Farming"
                            ? "activemenu"
                            : ""
                        }
                       ${
                         activemenuLink === "/Value_Addition"
                           ? "activemenu"
                           : ""
                       }
                        ${
                          activemenuLink === "/Market_Linkages"
                            ? "activemenu"
                            : ""
                        }
                        ${
                          activemenuLink === "/Organic_Certification"
                            ? "activemenu"
                            : ""
                        }
                        `}
                      >
                        SLM
                      </span>
                    </Link>
                    <span class="mr-auto">
                      <svg
                        class="fill-current h-4 w-4
                          transition duration-150 ease-in-out"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </span>
                  </div>
                  <ul
                    class="text-white absolute    transition duration-150 ease-in-out  hover:no-underline Ul_bgcolor"
                    style={{ width: "100%" }}
                  >
                    <li className="my-2 mx-4">
                      {" "}
                      SLM
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold ${
                          activemenuLink === "/Organic_Farming"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/sustainable_land_management/organic_farming_production_and_diversification/"
                        onClick={() => handlePageChange("/Organic_Farming")}
                      >
                        Organic Farming
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold ${
                          activemenuLink === "/Value_Addition"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/sustainable_land_management/value_addition _&_upgradation _of_aggregation_infrastructure"
                        onClick={() => handlePageChange("/Value_Addition")}
                      >
                        Value Addition
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold ${
                          activemenuLink === "/Market_Linkages"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/sustainable_land_management/establishing_effective_market_linkages/"
                        onClick={() => handlePageChange("/Market_Linkages")}
                      >
                        Market Linkages
                      </Link>
                      <Link
                        className={` hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold ${
                          activemenuLink === "/Organic_Certification"
                            ? "activemenu"
                            : ""
                        }`}
                        to="/sustainable_land_management/organic_certification_for_premier_organic_markets/"
                        onClick={() =>
                          handlePageChange("/Organic_Certification")
                        }
                      >
                        Organic Certification
                      </Link>
                    </li>
                  </ul>
                </li>
                <li class=" ">
                  <div className="flex items-center w-full">
                    <Link
                      to="/pmjvm"
                      onClick={() => handlePageChange("/pmjvm")}
                      className="w-full text-left flex items-center outline-none focus:outline-none cursor-pointer hover:no-underline"
                    >
                      <span
                        class={`w-full hover:text-amber-500  block py-2 px-4 my-1 text-sm font- bold
                        ${activemenuLink === "/pmjvm" ? "activemenu" : ""} 
                       
                        `}
                      >
                        PMJVM
                      </span>
                    </Link>
                  </div>
                </li>
              </ul>
            </div>

            <li>
              <div className="group inline-block ">
                <div className="flex items-center  lg:h-[83px] md:h-full h-full">
                  <Link
                    to="/main-menu-page/knowledge"
                    className={`lg:px-2 3xl:py-8 2xl:py-4 xl:py-4 lg:py-4 md:px-4 md:py-4 px-2 py-2 text-sm  flex-1 text-white  my-0 hover:text-amber-500    
                   ${activemenuLink === "/infocus" ? "activemenu" : ""}
                   ${activemenuLink === "/publication" ? "activemenu" : ""}
                   ${activemenuLink === "/Report & Studies" ? "activemenu" : ""}
                   ${activemenuLink === "/Resources" ? "activemenu" : ""}
                   ${activemenuLink === "/Project  Doc" ? "activemenu" : ""}
                   ${
                     activemenuLink === "/Updates of the Week"
                       ? "activemenu"
                       : ""
                   }
                   ${
                     activemenuLink === "/social-media/youtube2"
                       ? "activemenu"
                       : ""
                   }
                   ${activemenuLink === "/photo" ? "activemenu" : ""}
                
                   `}
                  >
                    KNOWLEDGE PORTAL
                  </Link>
                  <span>
                    <svg
                      className="fill-current h-4 w-4 transform group-hover:-rotate-180 ease-in-out text-white   "
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </span>
                </div>
                <ul
                  className="text-white   transform scale-0 group-hover:scale-100 absolute ease-in-out min-w-32 z-40 p-4 Ul_bgcolor border-t-[1px] border-gray-50 border-opacity-20 "
                  style={{ width: "30%" }}
                >
                  <li className="my-2">
                    <Link
                      className={`hover:text-amber-500  block py-2 px-4 my-1 text-sm     ${
                        activemenuLink === "/infocus" ? "activemenu" : ""
                      }`}
                      to="/infocus"
                      onClick={() => {handlePageChange("/infocus");
                        setIsOpen(false);}}
                    >
                      In Focus
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link
                      className={`hover:text-amber-500  block py-2 px-4 my-1 text-sm    ${
                        activemenuLink === "/publication" ? "activemenu" : ""
                      }`}
                      to="/publication"
                      onClick={() => {handlePageChange("/publication");
                        setIsOpen(false);}}
                    >
                      Publication
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link
                      className={`hover:text-amber-500  block py-2 px-4 my-1 text-sm    ${
                        activemenuLink === "/photo" ? "activemenu" : ""
                      }`}
                      to="/photo"
                      onClick={() => {handlePageChange("/photo");
                        setIsOpen(false);}}
                    >
                      Photo Gallery
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link
                      className={`hover:text-amber-500  block py-2 px-4 my-1 text-sm  ${
                        activemenuLink === "/Report & Studies"
                          ? "activemenu"
                          : ""
                      }`}
                      to="/Report"
                      onClick={() => {handlePageChange("/Report & Studies");
                        setIsOpen(false);}}
                    >
                      Report & Studies
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`hover:text-amber-500  block py-2 px-4 my-1 text-sm      ${
                        activemenuLink === "/Resources" ? "activemenu" : ""
                      }`}
                      to="/resource"
                      onClick={() => {handlePageChange("/Resources");
                        setIsOpen(false);}}
                    >
                      Resources
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`hover:text-amber-500  block py-2 px-4 my-1 text-sm      ${
                        activemenuLink === "/Project  Doc" ? "activemenu" : ""
                      }`}
                      to="/project_doc"
                      onClick={() => {handlePageChange("/Project  Doc");
                        setIsOpen(false);}}
                    >
                      Project Doc
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`hover:text-amber-500  block py-2 px-4 my-1 text-sm      ${
                        activemenuLink === "/Updates of the Week"
                          ? "activemenu"
                          : ""
                      }`}
                      to="/updateoftheweek"
                      onClick={() => {handlePageChange("/Updates of the Week");
                        setIsOpen(false);}}
                    >
                      Updates of the Week
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`hover:text-amber-500  block py-2 px-4 my-1 text-sm      ${
                        activemenuLink === "/social-media/youtube2"
                          ? "activemenu"
                          : ""
                      }`}
                      to="/social-media/youtube2"
                      onClick={() => {handlePageChange("/social-media/youtube2");
                        setIsOpen(false);}}
                    >
                      Video
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <div className="group inline-block ">
                <div className="flex items-center  lg:h-[83px] md:h-full h-full">
                  <Link
                    to="/main-menu-page/Update"
                    className={`lg:px-2 3xl:py-8 2xl:py-4 xl:py-4 lg:py-4 md:px-4 md:py-4 px-2 py-2 text-sm flex-1 text-white  my-0 hover:text-amber-500 p2    
                   ${activemenuLink === "/adverticement" ? "activemenu" : ""}  
                   ${activemenuLink === "/recruitment" ? "activemenu" : ""}  
                  
                   ${activemenuLink === "/good_tender" ? "activemenu" : ""}`}
                  >
                    UPDATE
                  </Link>
                  <span>
                    <svg
                      className="fill-current h-4 w-4 transform group-hover:-rotate-180 text-white 
      ease-in-out  "
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </span>
                </div>
                <ul
                  className="text-white transform scale-0 group-hover:scale-100 absolute ease-in-out min-w-32 z-40 p-4 Ul_bgcolor border-t-[1px] border-gray-50 border-opacity-20 "
                  style={{ width: "30%" }}
                >
                  <li className="my-2">
                    <Link
                      className={`hover:text-amber-500  block py-2 px-4 my-1 text-sm ${
                        activemenuLink === "/adverticement" ? "activemenu" : ""
                      }`}
                      to="/advertisement"
                      onClick={() => {handlePageChange("/adverticement");
                        setIsOpen(false);}}
                    >
                      Advertisement
                    </Link>
                  </li>
                  {/* <li className="my-2">
                    <Link
                      className={`hover:text-amber-500  block py-2 px-4 my-1 text-sm ${
                        activemenuLink === "/recruitment" ? "activemenu" : ""
                      }`}
                      to="/recruitment"
                      onClick={() => handlePageChange("/recruitment")}
                    >
                      Recruitment
                    </Link>
                  </li> */}

                  <li className="my-2">
                    <Link
                      className={`hover:text-amber-500  block py-2 px-4 my-1 text-sm ${
                        activemenuLink === "/good_tender" ? "activemenu" : ""
                      }`}
                      to="/tender"
                      onClick={() => {handlePageChange("/good_tender");
                        setIsOpen(false);}}
                    >
                      Goods & Tender
                    </Link>
                  </li>
                  {/* <li className='my-2'>
                    <Link className="  hover:text-amber-500  block py-2 px-4 my-1 text-sm " to="/Governing-council" onClick={() => handlePageChange('/Governing-council')}>
                      Governing Council
                    </Link>
                  </li>
                  <li>
                    <Link className="  hover:text-amber-500  block py-2 px-4 my-1 text-sm " to="/project_unit" onClick={() => handlePageChange('/project_unit')}>
                      Project Unit
                    </Link>
                  </li> */}
                </ul>
              </div>
            </li>

            <li className="lg:h-[83px] md:h-full h-full flex items-center  px-2">
              <Link
                className={`text-white p-2  hover:text-amber-500  ${
                  activemenuLink === "/blog" ? "activemenu" : ""
                }`}
                to="/blog"
                onClick={() => {handlePageChange("/blog");
                  setIsOpen(false);
                }}
              >
                BLOG
              </Link>
            </li>
            <li>
              <div className="group inline-block ">
                <div className="flex items-center lg:h-[83px] md:h-full h-full">
                  <Link
                    to="/green_meghalaya"
                    className={`lg:px-2 3xl:py-8 2xl:py-4 xl:py-4 lg:py-4 md:px-4 md:py-4 px-2 py-2 text-sm flex-1 text-white  my-0 hover:text-amber-500 p2    
                   ${
                     activemenuLink === "/green_meghalaya" ? "activemenu" : ""
                   }  
                 `}
                  >
                    GREEN MEGHALAYA (PES)
                  </Link>
                  <span>
                    <svg
                      className="fill-current h-4 w-4 transform group-hover:-rotate-180 text-white 
      ease-in-out  "
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </span>
                </div>
                <ul
                  className="text-white   transform scale-0 group-hover:scale-100 absolute ease-in-out min-w-32 z-40 p-4 Ul_bgcolor border-t-[1px] border-gray-50 border-opacity-20 "
                  style={{ width: "30%" }}
                >
                  <li className="my-2">
                    <Link
                      className={`hover:text-amber-500  block py-2 px-4 my-1 text-sm ${
                        activemenuLink === "/green_meghalaya"
                          ? "activemenu"
                          : ""
                      }`}
                      to="/green_meghalaya_dashboard/"
                      onClick={() => {handlePageChange("/green_meghalaya");
                        setIsOpen(false);}}
                    >
                      GREEN MEGHALAYA( PES ) DASHBOARD
                    </Link>
                  </li>

                  {/* <li className='my-2'>
                    <Link className="  hover:text-amber-500  block py-2 px-4 my-1 text-sm " to="/Governing-council" onClick={() => handlePageChange('/Governing-council')}>
                      Governing Council
                    </Link>
                  </li>
                  <li>
                    <Link className="  hover:text-amber-500  block py-2 px-4 my-1 text-sm " to="/project_unit" onClick={() => handlePageChange('/project_unit')}>
                      Project Unit
                    </Link>
                  </li> */}
                </ul>
              </div>
            </li>
            {/* <li className="my-2 p-2">
              <Link
                className={`text-white  my-2 hover:text-amber-500 p-2  ${
                  activemenuLink === "/green_meghalaya" ? "activemenu" : ""
                }`}
                to="/green_meghalaya"
                onClick={() => handlePageChange("/green_meghalaya")}
              >
                GREEN MEGHALAYA (PES)
              </Link>
            </li> */}

<li className="lg:h-[83px] md:h-full h-full flex items-center px-2">
  <Link
    className={`text-white my-2 hover:text-amber-500 p-2 ${
      activemenuLink === "/meghalaya-collectives" ? "activemenu" : ""
    }`}
    to="/meghalaya-collectives"
    onClick={() => {
      handlePageChange("/meghalaya-collectives");
      setIsOpen(false); // 👈 This will close the menu and make the logo visible again
    }}
  >
    MEGHALAYA COLLECTTIVES
  </Link>
</li>
            {/* <li className="my-2 p-2">
              <Link
                className={`text-white  my-2 hover:text-amber-500 p-2  ${
                  activemenuLink === "/pmjvm"
                    ? "activemenu"
                    : ""
                }`}
                to="/pmjvm"
                onClick={() => handlePageChange("/pmjvm")}
              >
                PMJVM
              </Link>
            </li> */}
          </ul>

          <div className="flex items-center lg:hidden">
            <button
              className={`text-white text-4xl font-bold opacity-100 hover:opacity-100 duration-300 mx-auto lg:mr-0 md:mr-2 mr-0 ${
                isOpen ? "hidden" : ""
              }`}
              onClick={toggleMenu}
            >
              &#9776;
            </button>
          </div>
        </div>
      </header>
      <main style={{ fontSize: `${fontSize}px` }} className="">
        <br />
        <br /> <br />
        <div className=" rounded-lg shadow-xl  bg-white   items-center justify-center pb-12">
          {children}
        </div>
      </main>

      <div
        className="lg:bg-cover bg-center "
        style={{ backgroundImage: `url(${footer})` }}
      >
        <footer
          className="p-8 text-justify text-white  bg-black bg-opacity-40  grid sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4"
          style={{ fontSize: `${fontSize}px` }}
        >
          <div className="overflow-hidden    ml-8 mt-5">
            <ol className="items-center justify-center">
              <h1 className="py-2 poppins-bold lg:text-lg sm:text-md">
                WHO WE ARE
              </h1>
              <li className="py-2 poppins-regular">
                <Link to="/about">About Us</Link>
              </li>
              {/* <li className="py-2 poppins-regular">
                <Link to="/contact">Contact Detail</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/contact">Feedback Form</Link>
              </li> */}
              <li className="py-2 poppins-regular">
                <Link to="/grievance">Grievance Redressal</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/Who_is_who">Who's Who</Link>
              </li>
            </ol>
          </div>
          <div className="overflow-hidden    ml-8 mt-5">
            <ol className="items-center justify-center">
              <h1 className="py-2 poppins-bold lg:text-lg sm:text-md">
                KNOWLEDGE PORTAL
              </h1>
              <li className="py-2 poppins-regular">
                <Link to="/infocus">Infocus</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/publication">Publication</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/Report">Report & Studies</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/studies">Studies</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/project_doc">Project Docs (LAMP and CLLMP)</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/interactivemenu_map">Interactivemenu Map</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/updateoftheweek">Updates of the Weeks</Link>
              </li>
            </ol>
          </div>
          <div className="overflow-hidden    ml-8 mt-5">
            <ol className="items-center justify-center">
              <h1 className="py-2 poppins-bold lg:text-lg sm:text-md">
                WHAT WE DO
              </h1>
              <li className="py-2 poppins-regular">
                <Link to="/mlamp/natural_resource">Environment</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/mlamp/rural_finance">Finance</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/mlamp/supply_chain">Entrepreneurship</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/mlamp/enterprise_development">Markets</Link>
              </li>
            </ol>
          </div>
          <div className="overflow-hidden    ml-8 mt-5">
            <ol className="items-center justify-center">
              <h1 className="py-2 poppins-bold lg:text-lg sm:text-md">
                QUICK LINKS
              </h1>

              <li className="py-2 poppins-regular">
                <Link to="/careers">Careers</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/accessibility_statement">
                  Accessibility Statement
                </Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/disclaimer">Disclaimer</Link>
              </li>

              <li className="py-2 poppins-regular">
                <Link to="/copyright">Copyright</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/website_policy"> Website Policy</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/privacy_policy"> Privacy Policy</Link>
              </li>
              <li className="py-2 poppins-regular">
                <Link to="/term_condition">Term & Condition</Link>
              </li>
            </ol>
          </div>
          <AnalyticsDashboard />
        </footer>
        {/* <div className='flex gap-4 mx-12 items-center justify-center p-8'>
  <Link to="/">
 <StaticImage src="../images/MBMAORG-logo.png" alt="My Image" width={100} style={{ height: '100%' }} className="" />
 </Link>
    <h1 className='text-cyan-800 font-bold'>© 2023 MBMA</h1>
      </div>  */}
      </div>
    </div>
  )
}

export default MyLayout
